// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/card.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "vigia-fleet-app")
// Destination      : packages/fleet/ui/src/card.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo vigia-fleet-app
//     node fleet/fleet.ts check --repo vigia-fleet-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { type ComponentProps, type ParentComponent, splitProps } from "solid-js";
import { cn } from "@vigia/shared";

const Card: ParentComponent<ComponentProps<"div">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <div
      class={cn(
        "rounded-xl border border-accent/25 bg-card text-card-foreground shadow",
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </div>
  );
};

const CardHeader: ParentComponent<ComponentProps<"div">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <div class={cn("flex flex-col space-y-1.5 p-6", local.class)} {...rest}>
      {local.children}
    </div>
  );
};

const CardTitle: ParentComponent<ComponentProps<"h3">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <h3 class={cn("font-semibold leading-none tracking-tight", local.class)} {...rest}>
      {local.children}
    </h3>
  );
};

const CardDescription: ParentComponent<ComponentProps<"p">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <p class={cn("text-sm text-muted-foreground", local.class)} {...rest}>
      {local.children}
    </p>
  );
};

const CardContent: ParentComponent<ComponentProps<"div">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <div class={cn("p-6 pt-0", local.class)} {...rest}>
      {local.children}
    </div>
  );
};

const CardFooter: ParentComponent<ComponentProps<"div">> = (props) => {
  const [local, rest] = splitProps(props, ["class", "children"]);
  return (
    <div class={cn("flex items-center p-6 pt-0", local.class)} {...rest}>
      {local.children}
    </div>
  );
};

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
